<template>
  <div class="page-wrapper">
    <HeaderComponent />

    <div class="page-content">
      <AppBreadcrumb :items="[{ label: 'Bosh sahifa' }]" />

      <a-row :gutter="[18, 18]">
        <a-col v-for="item in categories" :key="item.title" :xs="24" :sm="12" :lg="8" :xl="6">
          <CategoryCard
            :title="item.title"
            :description="item.description"
            :to="item.to"
            :icon="item.icon"
            :badge="item.badge"
            :badge-color="item.badgeColor"
            :disabled="item.disabled"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
import CategoryCard from '../components/CategoryCard.vue'

export default {
  components: {
    HeaderComponent,
    AppBreadcrumb,
    CategoryCard
  },
  data() {
    return {
      categories: [
        { 
          title: 'Real imtihon', 
          description: 'Asosiy imtihon rejimi', 
          to: '/real-exam', 
          icon: '📝' 
        },
        { 
          title: '10 ta biletlar', 
          description: '10 talik test biletlari', 
          to: '/tickets/10', 
          icon: '🔟' 
        },
        { 
          title: '20 tali biletlar', 
          description: '20 talik test biletlari', 
          to: '/tickets/20', 
          icon: '📚' 
        },
        { 
          title: '50 tali biletlar', 
          description: '50 talik test biletlari', 
          to: '/tickets/50', 
          icon: '🎯' 
        },
        { 
          title: 'Xato belgilagan savollarim', 
          description: 'Xato ishlangan savollar', 
          to: '/wrong-questions', 
          icon: '❌' 
        },
        { 
          title: 'Tibbiyot ma’lumotlari', 
          description: 'Tibbiy bilimlar', 
          to: '/medical-info', 
          icon: '🏥',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        },
        { 
          title: 'Yo‘l belgilari', 
          description: 'Yo‘l belgilari katalogi', 
          to: '/road-signs', 
          icon: '🚸',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        },
        { 
          title: 'Jarimalar', 
          description: 'Jarimalar ro‘yxati', 
          to: '/fines', 
          icon: '💸',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        }
      ]
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
}
</style>